<template>
	<div class="lillan-show__comments">
		<div class="lillan-show__comments-title">
			<h2>{{ context.translations.comments }}</h2>
		</div>
		<div v-for="comment in comments" class="lillan-show__comment">
			<div class="wysiwyg" v-html="comment.text"></div>
		</div>

		<div class="lillan-show__comment-write">
			<div>{{ context.translations.comment_on_the_show }}</div>
		</div>
		<form v-on:submit.prevent="send" v-if="!done">
			<textarea rows="6" v-model="comment"></textarea>
			<div>
			<button class="lillan-button-small"
					type="submit"
					v-bind:disabled="loading"
			>
				{{context.translations.send_comment}}
			</button>
			</div>
		</form>
		<div v-if="done" class="wysiwyg">
			{{context.translations.comment_awaiting_review}}
		</div>
	</div>
</template>

<script>
import axios from 'axios';
export default {
	props: ['context'],
	data: function () {
		return {
			comments: [],
			comment: '',
			loading: false,
			error: false,
			done: false,
		}
	},
	mounted: function () {
		axios.get(`${this.context.rest_api_url}lillan/v1/show-comments`, {
			params: {
				id: this.context.post_id,
			},
			headers: {
				'X-WP-Nonce': this.context.nonce,
			}
		}).then(response => {
			this.comments = response.data;
		})
	},
	methods: {
		send() {
			this.loading = true;
			axios.post(`${this.context.rest_api_url}lillan/v1/post-comment`, {
				post_id: this.context.post_id,
				comment: this.comment,
			}, {
				headers: {
					'X-WP-Nonce': this.context.nonce,
				}
			}).then(response => {
				this.loading = false;
				this.done = true;
			}).catch(() => {
				this.loading = false;
			})
		}
	}
}
</script>
